import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { BaseData } from 'src/app/interfaces/components/BaseData';

import { ApiResponse, ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class BaseDataService {
  private baseDataSubject = new BehaviorSubject<BaseData | null>(null);
  public baseData$ = this.baseDataSubject.asObservable();

  constructor(private apiService: ApiService) {}

  public getData(franchisee: string): void {
    if (!this.baseDataSubject.value) {
      this.apiService.get('dadosbase', { franquia: franchisee }).subscribe({
        next: (response: ApiResponse) => {
          if (response.status === 'success') {
            this.baseDataSubject.next(response.data);
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }
}
